<template>
  <vs-tabs alignment="left">
    <vs-tab :label="$tc('detail', 2)">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <div class="mb-3">
            <vs-input :label="$t('name')" :placeholder="$t('name')" v-model="companyFormData.name" class="w-full"/>
            <validation-error :model-error="companyFormErrors.name"></validation-error>
          </div>
          <vs-input :label="$t('context')" :placeholder="$t('context')" v-model="companyFormData.context" class="w-full mb-3"/>
          <vs-input :label="$t('dcontext')" :placeholder="$t('dcontext')" v-model="companyFormData.dcontext" class="w-full mb-3"/>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-input :label="$t('webfax_content')" :placeholder="$t('webfax_content')" v-model="companyFormData.webfax_content" class="w-full mb-3"/>
          <div class="mb-3">
            <label class="vs-input--label" v-text="$tc('server', 1)"></label>
            <v-select :options="serverOptions" :reduce="label => label.value" :placeholder="$tc('server', 1)" v-model="companyFormData.server_id" class="md:mb-0" style="height: 37.59px" />
          </div>
          <vs-input :label="$t('asterisk_name')" :placeholder="$t('asterisk_name')" v-model="companyFormData.asterisk_name" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">

          <div class="mb-3">
            <vs-input :label="$t('rec_login_page_url')" :placeholder="$t('rec_login_page_url')" v-model="companyFormData.rec_login_page_url" class="w-full"/>
            <validation-error :model-error="companyFormErrors.rec_login_page_url"></validation-error>
          </div>

          <div class="mb-3">
            <vs-input :label="$t('rec_username')" :placeholder="$t('rec_username')" v-model="companyFormData.rec_username" class="w-full"/>
            <validation-error :model-error="companyFormErrors.rec_username"></validation-error>
          </div>

          <div class="mb-3">
            <vs-input :label="$t('rec_password')" type="password" :placeholder="$t('rec_password')" v-model="companyFormData.rec_password" class="w-full"/>
            <validation-error :model-error="companyFormErrors.rec_password"></validation-error>
          </div>

        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-checkbox v-model="companyFormData.send_daily_report" class="mb-3"><span v-text="$t('send_daily_report')"></span></vs-checkbox>

          <div class="mb-3">
            <vs-input :label="$t('daily_report_email_recipient')" v-model="companyFormData.daily_report_email_recipient" class="w-full" :disabled="companyFormData.send_daily_report == 0"/>
            <validation-error :model-error="companyFormErrors.daily_report_email_recipient"></validation-error>
          </div>

          <div class="mb-3">
            <vs-input :label="$t('daily_report_email_recipient_cc')" v-model="companyFormData.daily_report_email_recipient_cc" class="w-full" :disabled="companyFormData.send_daily_report == 0"/>
            <validation-error :model-error="companyFormErrors.daily_report_email_recipient_cc"></validation-error>
          </div>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-checkbox v-model="companyFormData.allow_simple_crm" class="mb-3"><span v-text="$t('allow_simple_crm')"></span></vs-checkbox>
          <vs-checkbox v-model="companyFormData.is_free"><span v-text="$t('is_free')"></span></vs-checkbox>
        </div>

        <div class="vx-col md:w-1/3 sm:w-1/3 w-full">
          <vs-checkbox v-model="companyFormData.use_big" class="mb-3"><span v-text="$t('use_big')"></span></vs-checkbox>
          <vs-checkbox v-model="companyFormData.is_active"><span v-text="$t('is_active')"></span></vs-checkbox>
        </div>
      </div>
    </vs-tab>
    <vs-tab :label="$tc('extension', 2)">
      <vx-input-group class="mb-1" v-for="(extension, key) in companyFormData.extensions" :key="key">
        <vs-input placeholder="Extension Number" v-model="extension.number" />

        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              v-if="extension.id"
              @click.prevent="deleteModelByType(extension.id, key, 'extensions')">
            </vs-button>

            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-x"
              v-else
              @click.prevent="removeField(key, 'extensions')">
            </vs-button>
          </div>
        </template>
      </vx-input-group>

      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-plus"
        @click.prevent="addField('extensions')">
        Add Extension
      </vs-button>
    </vs-tab>
    <vs-tab :label="$t('queues')">
      <vx-input-group class="mb-1" v-for="(queue, key) in companyFormData.queues" :key="key">
        <vs-input placeholder="Queue Number" v-model="queue.number" />

        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              v-if="queue.id"
              @click.prevent="deleteModelByType(queue.id, key, 'queues')">
            </vs-button>

            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-x"
              v-else
              @click.prevent="removeField(key, 'queues')">
            </vs-button>
          </div>
        </template>
      </vx-input-group>

      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-plus"
        @click.prevent="addField('queues')">
        Add Queues
      </vs-button>
    </vs-tab>
    <vs-tab :label="$t('did')">
      <vx-input-group class="mb-1" v-for="(did, key) in companyFormData.dids" :key="key">
        <vs-input placeholder="DID Number" v-model="did.number" />

        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              v-if="did.id"
              @click.prevent="deleteModelByType(did.id, key, 'dids')">
            </vs-button>

            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-x"
              v-else
              @click.prevent="removeField(key, 'dids')">
            </vs-button>
          </div>
        </template>
      </vx-input-group>

      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-plus"
        @click.prevent="addField('dids')">
        Add DID
      </vs-button>
    </vs-tab>
    <vs-tab :label="$t('fax_did_management')">
      <p class="mb-3 text-sm" v-text="$t('fax_did_hint')"></p>

      <div class="vx-row mb-2" v-for="(faxDid, key) in companyFormData.fax_dids" :key="key">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vs-input :label="$t('fax_did_match_number')" placeholder="0444" v-model="faxDid.number" class="w-full"/>
          <span class="form-text text-muted" v-text="$t('fax_did_match_number_hint')"></span>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <vx-input-group class="mb-0">
            <vs-input :label="$t('fax_did_display_number')" placeholder="070-4689-2121" v-model="faxDid.display_number" class="w-full"/>

            <template slot="append">
              <div class="append-text btn-addon" style="margin-top: 1.2rem;">
                <vs-button
                  color="danger"
                  icon-pack="feather"
                  icon="icon-trash-2"
                  v-if="faxDid.id"
                  @click.prevent="deleteModelByType(faxDid.id, key, 'fax_dids')">
                </vs-button>

                <vs-button
                  color="danger"
                  icon-pack="feather"
                  icon="icon-x"
                  v-else
                  @click.prevent="removeField(key, 'fax_dids')">
                </vs-button>
              </div>
            </template>
          </vx-input-group>
          <span class="form-text text-muted" v-text="$t('fax_did_display_number_hint')"></span>
        </div>
      </div>

      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-plus"
        @click.prevent="addField('fax_dids')">
        Add Fax DID
      </vs-button>
    </vs-tab>
    <vs-tab :label="$tc('keyword', 2)">
      <vx-input-group class="mb-1" v-for="(keyword, key) in companyFormData.keywords" :key="key">
        <vs-input placeholder="Keyword" v-model="keyword.name" />

        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              v-if="keyword.id"
              @click.prevent="deleteModelByType(keyword.id, key, 'keywords')">
            </vs-button>

            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-x"
              v-else
              @click.prevent="removeField(key, 'keywords')">
            </vs-button>
          </div>
        </template>
      </vx-input-group>

      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-plus"
        @click.prevent="addField('keywords')">
        Add Keyword
      </vs-button>
    </vs-tab>
    <vs-tab :label="$t('inbound_details')">
      <template v-for="(inbound_detail, key) in companyFormData.inbound_details_settings">
        <vx-input-group class="mb-1 inboundDetailsGroup" :key="key">
          <vs-input placeholder="Setting" class="mr-1" v-model="inbound_detail.settings" />
          <vs-input placeholder="Label" v-model="inbound_detail.label" />

          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button
                color="danger"
                icon-pack="feather"
                icon="icon-trash-2"
                v-if="inbound_detail.id"
                @click.prevent="deleteInboundDetail(inbound_detail.company_id, inbound_detail.id, key)">
              </vs-button>

              <vs-button
                color="danger"
                icon-pack="feather"
                icon="icon-x"
                v-else
                @click.prevent="removeInboundDetail(key)">
              </vs-button>
            </div>
          </template>
        </vx-input-group>

        <vx-input-group class="mb-1" v-for="(item, itemKey) in inbound_detail.values" :key="itemKey">
          <vs-input placeholder="Key" class="mr-1" v-model="item.key" />
          <vs-input placeholder="Value" v-model="item.value" />

          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button
                color="danger"
                icon-pack="feather"
                icon="icon-trash-2"
                v-if="item.id"
                @click.prevent="deleteInboundDetailItem(inbound_detail.company_id, inbound_detail.id, item.id, key, itemKey)">
              </vs-button>

              <vs-button
                color="danger"
                icon-pack="feather"
                icon="icon-x"
                v-else
                @click.prevent="removeInboundDetailItem(key, itemKey)">
              </vs-button>
            </div>
          </template>
        </vx-input-group>

        <vs-button
          color="primary"
          icon-pack="feather"
          icon="icon-plus"
          class="mb-2"
          @click.prevent="addInboundDetailItem(key)" :key="key">
          Add Item
        </vs-button>
      </template>

      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-plus"
        class="mb-2"
        @click.prevent="addInboundDetail()">
        Add Settings
      </vs-button>
    </vs-tab>
    <vs-tab :label="$t('time_groups')">

      <vx-input-group class="mb-1" v-for="(time_group, key) in companyFormData.time_groups" :key="key">
        <vs-input placeholder="Time Group" class="mr-1" v-model="time_group.name" />
        <vs-input placeholder="Custom Label" v-model="time_group.custom_label" />

        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              v-if="time_group.id"
              @click.prevent="deleteModelByType(time_group.id, key, 'time_groups')">
            </vs-button>

            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-x"
              v-else
              @click.prevent="removeField(key, 'time_groups')">
            </vs-button>
          </div>
        </template>
      </vx-input-group>

      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-plus"
        @click.prevent="addField('time_groups')">
        Add Time Groups
      </vs-button>
    </vs-tab>
    <vs-tab :label="$tc('transfer', 2)">
      <vx-input-group class="mb-1" v-for="(transfer, key) in companyFormData.transfer_numbers" :key="key" prepend-classes="border border-solid border-grey">
        <template slot="prepend">
          <div class="prepend-text">
            <vs-checkbox v-model="transfer.is_active"></vs-checkbox>
          </div>
        </template>

        <vs-input placeholder="Transfer Number" v-model="transfer.extension" />

        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              v-if="transfer.id"
              @click.prevent="deleteModelByType(transfer.id, key, 'transfer_numbers')">
            </vs-button>

            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-x"
              v-else
              @click.prevent="removeField(key, 'transfer_numbers')">
            </vs-button>
          </div>
        </template>
      </vx-input-group>

      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-plus"
        @click.prevent="addField('transfer_numbers')">
        Add Transfers
      </vs-button>
    </vs-tab>
    <vs-tab :label="$tc('permission', 2)">
      <div class="vx-row">
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_manage_messages">
            <span v-text="$t('sms')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_transfer">
            <span v-text="$tc('transfer', 2)"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_worktime_switch">
            <span v-text="$t('permission_work_time_switch')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_dashboard">
            <span v-text="$t('dashboard')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_consultations">
            <span v-text="$tc('consultation', 2)"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_task">
            <span v-text="$t('tasks')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_call_statistics">
            <span v-text="$t('call_statistics')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_slogan">
            <span v-text="$t('slogan')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_schedule_push_notification">
            <span v-text="$t('schedule_push_notification')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_provide_agent_api">
            <span v-text="$t('can_provide_agent_api')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_branch_extension">
            <span v-text="$t('branch_extension')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_extension_status_data_analysis">
            <span v-text="$t('extension_status_data_analysis')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="companyFormData.company_permissions.company_call_time_notation_method">
            <span v-text="$t('call_time_notation_method')"></span>
          </vs-checkbox>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_manage_fax">
            <span v-text="$t('fax')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_receive_fax">
            <span v-text="$t('company_can_receive_fax')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_queue_history">
            <span v-text="$t('queue_history')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_outbound_call_popup">
            <span v-text="$t('permission_outbound_call_popup')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_configuration">
            <span v-text="$t('configuration')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_members">
            <span v-text="$t('members')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_projects">
            <span v-text="$tc('project', 2)"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_message_management">
            <span v-text="$t('message_management')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_show_dashboard_statistics">
            <span v-text="$t('dashboard_statistics')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_upload_sound_file">
            <span v-text="$t('upload_sound_file')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.ob_queue_status">
            <span v-text="$t('ob_queue_status')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_blacklist">
            <span v-text="$t('blacklist')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.send_email_function">
            <span v-text="$t('send_email_function')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="companyFormData.company_permissions.company_hide_reset_button_for_queues">
            <span v-text="$t('company_hide_reset_button_for_queues')"></span>
          </vs-checkbox>
        </div>
        <div class="vx-col md:w-1/3 sm:w-1/2 w-full">
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_manage_time_conditions">
            <span v-text="$t('holiday')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_recording_manager">
            <span v-text="$t('recording_manager')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_click_to_call_outbound_call_popup">
            <span v-text="$t('click_to_call_outbound_call_popup')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_manage_users">
            <span v-text="$t('manage_users')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_my_account">
            <span v-text="$t('my_account')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_queues">
            <span v-text="$t('queues')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_callback_share_function">
            <span v-text="$t('callback_share_function')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_callback_amount">
            <span v-text="$t('callback_amount')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_auto_call_system">
            <span v-text="$t('auto_call_system_studymax')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_callnote">
            <span v-text="$t('callnote')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_use_queue_all">
            <span v-text="$t('queue_status_all')"></span>
          </vs-checkbox>
          <vs-checkbox class="mb-3" v-model="companyFormData.company_permissions.company_can_auto_call_system_public">
            <span v-text="$t('auto_call_system_public')"></span>
          </vs-checkbox>
          <vs-checkbox v-model="companyFormData.company_permissions.company_can_modify_queue">
            <span v-text="$t('modify_queue')"></span>
          </vs-checkbox>
        </div>
      </div>
    </vs-tab>
    <vs-tab :label="$t('worktime')">
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('worktime_check_url')" :placeholder="$t('worktime_check_url')" v-model="companyFormData.worktime_check_url" class="w-full"/>
            <validation-error :model-error="companyFormErrors.worktime_check_url"></validation-error>
          </div>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('worktime_update_status_url')" :placeholder="$t('worktime_update_status_url')" v-model="companyFormData.worktime_update_status_url" class="w-full"/>
            <validation-error :model-error="companyFormErrors.worktime_update_status_url"></validation-error>
          </div>
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('worktime_start')" v-model="companyFormData.worktime_start" type="time" class="w-full"/>
            <validation-error :model-error="companyFormErrors.worktime_start"></validation-error>
          </div>
        </div>
        <div class="vx-col md:w-1/2 sm:w-1/2 w-full">
          <div class="mb-3">
            <vs-input :label="$t('worktime_end')" v-model="companyFormData.worktime_end" type="time" class="w-full"/>
            <validation-error :model-error="companyFormErrors.worktime_end"></validation-error>
          </div>
        </div>
      </div>
    </vs-tab>
    <vs-tab :label="$t('queue_status')">
      <vx-input-group class="mb-1" v-for="(queue_status, key) in companyFormData.queue_statuses" :key="key">
        <vs-input placeholder="Text" class="mr-1" v-model="queue_status.text" />
        <vs-input placeholder="Caller ID" class="mr-1" v-model="queue_status.callerId" />
        <vs-input placeholder="Extension" class="mr-1" v-model="queue_status.extension" />
        <vs-input placeholder="Caller Number" v-model="queue_status.callerNumber" />
        <template slot="append">
          <div class="append-text btn-addon">
            <vs-button
              color="primary"
              icon-pack="feather"
              icon="icon-arrow-down"
              style="border-right: solid 1px #f1f1f1;"
              @click.prevent="moveDown(key)"
              :disabled="key+1==companyFormData.queue_statuses.length"
            >
            </vs-button>
            <vs-button
              color="primary"
              icon-pack="feather"
              icon="icon-arrow-up"
              style="border-right: solid 1px #f1f1f1;"
              :disabled="key==0"
              @click.prevent="moveUp(key)"
            >
            </vs-button>
            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-trash-2"
              v-if="queue_status.id"
              @click.prevent="deleteModelByType(queue_status.id, key, 'queue_statuses')">
            </vs-button>
            <vs-button
              color="danger"
              icon-pack="feather"
              icon="icon-x"
              v-else
              @click.prevent="removeField(key, 'queue_statuses')">
            </vs-button>
          </div>
        </template>
      </vx-input-group>

      <vs-button
        color="primary"
        icon-pack="feather"
        icon="icon-plus"
        @click.prevent="addField('queue_statuses')">
        Add Queue Status
      </vs-button>
    </vs-tab>

  </vs-tabs>
</template>

<script>
import Company from '@/models/Company'
import { EventBus } from '@/../eventbus'
import { companyFormData } from '@/config/formData'

export default {
  name: 'Shared.Management.Company.Manage',
  data () {
    return {
      companyFormData,
      companyFormErrors: {}
    }
  },
  props: {
    serverOptions: {
      type: Array,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  mounted () {
    this.initCompanyFormData()
    EventBus.$on('initCompanyFormData', this.initCompanyFormData)
    EventBus.$on('initSubmitCompany', this.submit)
    EventBus.$on('initEditCompany', this.edit)
  },
  beforeDestroy () {
    EventBus.$off('initCompanyFormData', this.initCompanyFormData)
    EventBus.$off('initSubmitCompany', this.submit)
    EventBus.$off('initEditCompany', this.edit)
  },
  methods: {
    async submit () {
      this.$vs.loading({background: 'primary', color: '#fff', container: '#manageCompanyButton', scale: 0.45})

      try {
        const response = this.mode === 'store' ? await Company.store(this.companyFormData) : await Company.update(this.companyFormData)

        this.$emit('submitCompanySuccess', response)
        this.initCompanyFormData()
      } catch (e) {
        const errors = this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
        this.companyFormErrors = errors.validationErrors
      }

      this.$vs.loading.close('#manageCompanyButton > .con-vs-loading')
    },
    async edit (id) {
      this.$vs.loading({container: '#companyEditFormDataContainer'})

      try {
        const response = await Company.view({ id })
        this.companyFormData = response.data.company
        if (this.companyFormData.inbound_details_settings.length === 0) {
          this.initDefaultInboundDetailsSettings()
        }
      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }

      this.$vs.loading.close('#companyEditFormDataContainer > .con-vs-loading')
    },
    initCompanyFormData () {
      this.companyFormData = companyFormData
      this.companyFormErrors = {}
      this.initDefaultInboundDetailsSettings()
    },
    initDefaultInboundDetailsSettings () {
      this.companyFormData.inbound_details_settings = [
        {
          id: '',
          settings: 'did_array',
          label: 'DID (서비스명)',
          values: []
        }, {
          id: '',
          settings: 'did_outbound_array',
          label: 'DID - OUTBOUND',
          values: []
        }, {
          id: '',
          settings: 'dcontext_array',
          label: 'DCONTEXT (처리결과) (1)',
          values: []
        }, {
          id: '',
          settings: 'dst_array',
          label: 'DST (처리결과) (2)',
          values: []
        }, {
          id: '',
          settings: 'lastdata_array',
          label: 'LASTDATA (처리결과) (3)',
          values: []
        }, {
          id: '',
          settings: 'ivr_array',
          label: 'IVR (IVR 스텝)',
          values: []
        }
      ]
    },
    async deleteModelByType (id, key, type) {
      if (confirm(`Are you sure you want to delete the selected ${type}?`)) {
        try {
          const response = await Company.destroyData({ data_type: type, id })
          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: response.data,
            confirmButton: this.$t('confirm')
          })
          this.companyFormData[type].splice(key, 1)

          this.$emit('deleteItemsSuccess')
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    moveDown (key) {
      if (key < this.companyFormData.queue_statuses.length - 1) {
        const temp = this.companyFormData.queue_statuses[key]
        this.companyFormData.queue_statuses.splice(key, 1)
        this.companyFormData.queue_statuses.splice(key + 1, 0, temp)
      }
    },
    moveUp (key) {
      if (key > 0) {
        // Swap the item with the one above it
        const temp = this.companyFormData.queue_statuses[key]
        this.companyFormData.queue_statuses.splice(key, 1)
        this.companyFormData.queue_statuses.splice(key - 1, 0, temp)
      }
    },
    async deleteInboundDetail (companyId, id, key) {
      if (confirm('Are you sure you want to delete the selected inbound details?')) {
        try {
          const response = await Company.destroyData({ data_type: 'inbound_detail', company_id: companyId, id })
          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })
          this.companyFormData['inbound_details_settings'].splice(key, 1)

          this.$emit('deleteItemsSuccess')
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    async deleteInboundDetailItem (companyId, inboundDetailId, inboundDetailItemId, key, itemKey) {
      if (confirm('Are you sure you want to delete the selected item?')) {
        try {
          const response = await Company.destroyData({ data_type: 'inbound_detail_item', company_id: companyId, inbound_detail_id: inboundDetailId, inbound_detail_item_id: inboundDetailItemId })
          this.$swalHelper.success({
            title: this.$t('action_success'),
            text: this.$t(response.data),
            confirmButton: this.$t('confirm')
          })
          this.companyFormData.inbound_details_settings[key].values.splice(itemKey, 1)

          this.$emit('deleteItemsSuccess')
        } catch (e) {
          this.$swalHelper.displayCatchError({
            title: 'Error!',
            errorObject: e,
            confirmButton: this.$t('confirm')
          })
        }
      }
    },
    addInboundDetailItem (key) {
      this.companyFormData.inbound_details_settings[key].values.push({
        id: '',
        key: '',
        values: ''
      })
    },
    removeInboundDetailItem (key, itemKey) {
      this.companyFormData.inbound_details_settings[key].values.splice(itemKey, 1)
    },
    addInboundDetail () {
      this.companyFormData.inbound_details_settings.push({
        id: '',
        label: '',
        settings: '',
        values: []
      })
    },
    removeInboundDetail (key) {
      this.companyFormData['inbound_details_settings'].splice(key, 1)
    },
    addField (name) {
      this.companyFormData[name].push({
        id: '',
        number: '', // either number or name, depends on the database column name.
        display_number: '', // for fax dids
        name: '',
        extension: '', // for transfer numbers
        isActive: false // for transfer numbers.
      })
    },
    removeField (key, name) {
      this.companyFormData[name].splice(key, 1)
    }
  }
}
</script>

<style lang="scss">
  .vs-tabs--content {
    padding: 25px 10px;
  }
  .vx-input-group {
    .vx-input-group-prepend.form-element-border {
      border-color: rgba(0,0,0,0.25);
    }
  }
  .vx-input-group-default {
    display: flex;

    .vs-input {
      input {
        border-radius: 6px !important;
      }

      &:last-child {
        input {
          border-top-right-radius: 0 !important;
          border-bottom-right-radius: 0 !important;
        }
      }
    }
  }
</style>
